<div class="otp-wrap">
  <h3>{{ 'OTP.TITLE' | translate }}</h3>
  <p class="description">
    {{ 'OTP.DESCRIPTION' | translate }} <br/> {{ phoneNumber }}
  </p>

  <div class="change-number-wrap">
    <p class="action" *ngIf="!changingNumber" (click)="changingNumber = true">{{ 'OTP.CHANGE_NUMBER' | translate }}</p>

    <div class="form-group" *ngIf="changingNumber">
      <input id="change-number" type="text" class="form-control"
             [placeholder]="'OTP.PLACEHOLDER' | translate" [(ngModel)]="phoneNumber"/>
      <button class="btn btn-secondary with-loader"
              (click)="changeNumber()">{{ 'OTP.SAVE_BUTTON' | translate }} <span class="loader" *ngIf="updatingPhoneLoading"></span></button>
    </div>
    <small *ngIf="updatingPhoneError" class="text-danger">
      {{ 'OTP.UPDATE_FAILED' | translate }}
    </small>
  </div>

  <div class="otp-code-wrap">
    <input type="text" maxlength="1" class="otp-input" #otp1
           (input)="moveFocus(otp1, otp2)" (keydown)="moveBack($event, otp1)">
    <input type="text" maxlength="1" class="otp-input" #otp2
           (input)="moveFocus(otp2, otp3)" (keydown)="moveBack($event, otp1)">
    <input type="text" maxlength="1" class="otp-input" #otp3
           (input)="moveFocus(otp3, otp4)" (keydown)="moveBack($event, otp2)">
    <input type="text" maxlength="1" class="otp-input" #otp4
           (input)="moveFocus(otp4, otp5)" (keydown)="moveBack($event, otp3)">
    <input type="text" maxlength="1" class="otp-input" #otp5
           (input)="moveFocus(otp5, otp6)" (keydown)="moveBack($event, otp4)">
    <input type="text" maxlength="1" class="otp-input" #otp6 (keydown)="moveBack($event, otp5)">
  </div>

  <div class="otp-resend-wrap">
    <div class="timer" *ngIf="!error">{{timerDisplay}}</div>
    <small *ngIf="error" class="text-danger">
      {{ 'OTP.INVALID_PHONE' | translate }}
    </small>
    <button class="btn btn-secondary" (click)="resendOTP()" [disabled]="!isResendEnabled">
      {{ 'OTP.RESEND_BUTTON' | translate }}
    </button>
  </div>

  <div class="button-wrap">
    <small *ngIf="verifyError" class="text-danger">
      {{ 'OTP.VERIFY_FAILED' | translate }}
    </small>
    <button class="btn" [ngClass]="{'btn-primary-henterpant': henterPantMode, 'btn-primary': giPantMode}"
            (click)="verify()" [disabled]="!checkCode()">
      {{ 'OTP.VERIFY_BUTTON' | translate }}
      <span class="loader" *ngIf="verifyLoading"></span>
    </button>
    <p>{{ 'OTP.NO_CODE_RECEIVED' | translate }}</p>
  </div>
</div>
